import axios from 'axios'

import { Toast } from 'vant';
import Qs from 'qs'
import router from '@/router'
import { isAndroidIos,isAndroid} from '@/utils/validate'
// 创建axios实例
let baseURL = process.env.VERSION === 'production' ? 'https://api.homesocial.cn/' : process.env.VERSION === 'test' ? 'https://uat-api.homesocial.cn/' : 'https://uat-api.homesocial.cn/'
// let baseURL ='https://api.homesocial.cn/'
axios.defaults.headers['Content-Type'] = 'application/json';
const service = axios.create({
    baseURL, // api 的 base_url;
    timeout: 60000, // 请求超时时间
})

// request拦截器
let _os = '3'
if (isAndroidIos() != 'unknown') {
  if (isAndroid()) {
    _os = '2'
  } else {
    _os = '1'
  }
}
service.interceptors.request.use(
        config => {
            // X-TOKEN

            const token = localStorage.getItem('token') || ""
            token && (config.headers['X-TOKEN'] = token);
            let commonObj={
                _channel:(config.data&&config.data['_channel'])?config.data['_channel']:localStorage.getItem('_channel'),
                _package: localStorage.getItem('_package'),
                _did: localStorage.getItem('_did') || '',
                _os:localStorage.getItem('_os')|| _os,
                _ua: navigator.userAgent,
                flag: '2',
                _form_package: 1,
                refer: location.protocol + '//' + location.host,
                platform: '0',
                _user_id: localStorage.getItem('user_id'),
                _version:localStorage.getItem("_version")||'',
                _appname:localStorage.getItem('appname')||'智借',
                _appcompany:localStorage.getItem('appcompany')||'河北给力融资担保有限公司',
                t: new Date().getTime(),
            }
            //方法为post
            if(config.method=='post'){
                if(config.headers['Content-Type'].indexOf('application/json')>-1){
                    config.data ={
                        ...commonObj,
                        ...config.data
                    }
                }else if(config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded')>-1&&config.url.indexOf('app/record/shanqian')==-1){
                    config.data =Qs.stringify({
                        ...commonObj,
                        ...config.data
                    })
                }
            }else{
                //方法为get
                config['params']=Object.assign({},(config['params']||{}),{
                    ...commonObj,
                })
            }
            
            return config
            
            
        },
        error => {
            // Do something with request error
          return Promise.reject(error)
        }
    )
    // response 拦截器
service.interceptors.response.use(
    response => {
        if(!response){
          Toast.clear()
          return Promise.reject('error')
        }
        if (response.status == 200) {
            // console.log(router.currentRoute)
            // if (response.data.code != 200) {
            //     Toast.clear()
            //     Toast.fail({
            //         message: response.data.message,
            //         duration: 2000
            //     })

            // }
            return response.data
        } else {
            return Promise.reject('error')
        }
    },
    error => {
        if(!error){
          Toast.clear()
          return Promise.reject(error);
        }
        if (error.response &&error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    // router.replace({
                    //     path: '/login',
                    //     query: { redirect: router.currentRoute.fullPath }
                    // });
                    Toast({
                      message: '用户未登录',
                      duration: 1000,
                      forbidClick: true
                  });
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    Toast({
                        message: '登录过期，请重新登录',
                        duration: 1000,
                        forbidClick: true
                    });
                    // 清除token
                    localStorage.removeItem('token');
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    // setTimeout(() => {
                    //     router.replace({
                    //         path: '/login',
                    //         query: {
                    //             redirect: router.currentRoute.fullPath
                    //         }
                    //     });
                    // }, 1000);
                    break;
                    // 404请求不存在
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    // router.push({
                    //     path: '/refresh',
                    //     query: {
                    //         redirect: router.currentRoute.fullPath
                    //     }
                    // })
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    Toast({
                        message:error.response.message|| error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error);
        }

    }
)
export default service



// WEBPACK FOOTER //
// ./src/api/request.js